import { Router, activationStrategy } from 'aurelia-router';
import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { BaseView } from 'Common/BaseView';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { I18N } from 'aurelia-i18n';
import { PromptController } from 'Code/Prompts/PromptController';
import { StringHelper } from 'Code/Helpers/StringHelper';

@autoinject
export class ListBaseView extends BaseView {


    public entityName: string = StringHelper.Empty();
    protected router: Router = null;
    protected routeConfig: any = null;
    protected dataService: DataService = null;
    protected promptController: PromptController = null;
    protected i18n: I18N = null;

    constructor(dataService: DataService, router: Router, promptController: PromptController, i18n: I18N) {
        super();

        this.dataService = dataService;
        this.router = router;
        this.promptController = promptController;
        this.i18n = i18n;
    }

    activate(params, routeConfig, $navigationInstruction) {
        this.entityName = params.entityName;
        this.routeConfig = routeConfig;
    }

    async bind() {
    }
}
